<div class="astrea-profile-security">
    <mat-card class="p-2">
        <mat-card-content>

            <div class="astrea-subtitle my-2">
                <h2>{{ 'profile.security.security' | translate }}</h2>
            </div>

            <div class="change-pass mt-4">
                <h4>{{ 'profile.security.change_pass' | translate }}</h4>
                <p>
                    {{ 'profile.security.change_pass_txt_1' | translate }} <strong> {{ user.email }} </strong> {{ 'profile.security.change_pass_txt_2' | translate }}
                </p>
                <div class="d-flex">
                    <button (click)="changePass()" class="btn btn-green mt-3" mat-button>
                        {{ 'profile.security.send_email' | translate }}
                    </button>
                    <astrea-loading *ngIf="loading" class="mt-3 ml-2"></astrea-loading>
                </div>
            </div>

        </mat-card-content>
    </mat-card>
</div>
